export default "/images/laptop_background__home.png";